module.exports = __webpack_public_path__ + "static/laurie-51243b146c8ea88bbc4e2de028f9ce11.png";